import { Text } from '_/components';
import themes from '_/constants/themes';
import React from 'react';
import { View, StyleSheet } from 'react-native';
import { useTranslation } from 'react-i18next';
import { MeetingGuest } from '_/hooks/MeetingsProvider';

interface GuestProps {
  guest: MeetingGuest;
}

export default function Guest({ guest }: GuestProps) {
  const { t } = useTranslation();

  const identifier =
    guest.email || guest.phone || (guest.idNumber ? `${t('Document')}: ${guest.idNumber}` : '—');

  const label = guest.name ? `${guest.name} — ${identifier}` : identifier;

  return (
    <View style={styles.container}>
      <View style={styles.dataContainer}>
        <Text style={styles.email}>{label}</Text>
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    alignItems: 'center',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    flex: 1,
    paddingVertical: 12,
  },
  dataContainer: {
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'flex-start',
    flex: 1,
    marginLeft: 12,
  },
  email: {
    color: themes.colors.darkQuaternary,
    fontSize: 12,
    lineHeight: 14,
  },
});
